import {createContext} from 'react'

import type {BuildId} from '../../../../types'
import type {FullLogTarget} from '../BuildLog.types'

export const BuildIdContext = createContext<BuildId | null | undefined>(undefined)
export const TargetContext = createContext<FullLogTarget>('page')
